// Vivienne compact quick add
(function() {
  if (window.__vivienneCompactQuickAdd) return;
  window.__vivienneCompactQuickAdd = true;

  function getModal(id) { return document.getElementById(id); }
  function getVariants(modal) {
    var script = modal && modal.querySelector('[data-vivienne-variants]');
    if (!script) return [];
    try { return JSON.parse(script.textContent || '[]'); } catch (e) { return []; }
  }
  function getSelected(modal) {
    return Array.prototype.map.call(modal.querySelectorAll('.vivienne-quick-option'), function(fieldset) {
      var selected = fieldset.querySelector('.vivienne-quick-choice.is-selected');
      return selected ? selected.dataset.vivienneOptionValue : null;
    });
  }
  function findVariant(variants, selected) {
    return variants.find(function(variant) {
      return selected.every(function(value, index) { return !value || variant.options[index] === value; });
    }) || variants[0];
  }
  function optionAvailable(variants, selected, optionIndex, value) {
    return variants.some(function(variant) {
      if (!variant.available || variant.options[optionIndex] !== value) return false;
      return selected.every(function(selectedValue, index) {
        return index === optionIndex || !selectedValue || variant.options[index] === selectedValue;
      });
    });
  }
  function updateModal(modal) {
    var variants = getVariants(modal);
    var selected = getSelected(modal);
    var variant = findVariant(variants, selected);
    var idInput = modal.querySelector('[data-vivienne-variant-id]');
    var submit = modal.querySelector('[data-vivienne-submit]');
    if (idInput && variant) idInput.value = variant.id;

    modal.querySelectorAll('.vivienne-quick-option').forEach(function(fieldset, optionIndex) {
      var current = fieldset.querySelector('[data-vivienne-option-current]');
      if (current) current.textContent = selected[optionIndex] || '';
      fieldset.querySelectorAll('.vivienne-quick-choice').forEach(function(choice) {
        var isAvailable = optionAvailable(variants, selected, optionIndex, choice.dataset.vivienneOptionValue);
        choice.classList.toggle('is-disabled', !isAvailable);
        choice.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    });

    if (submit) {
      var available = !!(variant && variant.available);
      submit.disabled = !available;
      submit.textContent = available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
    }
  }
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('vivienne-quick-open');
    updateModal(modal);
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    if (!document.querySelector('.vivienne-quick-modal.is-open')) {
      document.body.classList.remove('vivienne-quick-open');
    }
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('[data-vivienne-quick-open]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(getModal(trigger.dataset.vivienneQuickOpen));
      return;
    }

    var close = event.target.closest && event.target.closest('[data-vivienne-quick-close]');
    if (close) {
      event.preventDefault();
      closeModal(close.closest('.vivienne-quick-modal'));
      return;
    }

    var choice = event.target.closest && event.target.closest('.vivienne-quick-choice');
    if (choice) {
      event.preventDefault();
      var fieldset = choice.closest('.vivienne-quick-option');
      var modal = choice.closest('.vivienne-quick-modal');
      fieldset.querySelectorAll('.vivienne-quick-choice').forEach(function(btn) { btn.classList.remove('is-selected'); });
      choice.classList.add('is-selected');
      updateModal(modal);
    }
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target.closest && event.target.closest('[data-vivienne-quick-form]');
    if (!form) return;
    event.preventDefault();
    var modal = form.closest('.vivienne-quick-modal');
    var submit = form.querySelector('[data-vivienne-submit]');
    var idInput = form.querySelector('[data-vivienne-variant-id]');
    if (!idInput || !idInput.value || !submit || submit.disabled) return;

    submit.classList.add('is-loading');
    submit.disabled = true;
    submit.textContent = 'AJOUT...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    }).then(function(response) {
      if (!response.ok) throw new Error('Ajout au panier impossible');
      return response.json();
    }).then(function() {
      submit.classList.remove('is-loading');
      submit.textContent = 'AJOUTÉ';
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function() { closeModal(modal); }, 650);
    }).catch(function() {
      submit.classList.remove('is-loading');
      submit.disabled = false;
      submit.textContent = 'RÉESSAYER';
    });
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.vivienne-quick-modal.is-open').forEach(closeModal);
    }
  });
})();
